import Card from "@/components/card"
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import { Icon } from "@/icons/icon"
import { cn } from "@/lib/utils"
import { ReactNode, useState } from "react"

export interface CollapsibleCardProps {
  className?: string
  title?: string
  hideTitle?: boolean
  actions?: ReactNode
  children?: ReactNode
}

export default function CollapsibleCard({
  className,
  title,
  hideTitle,
  actions,
  children,
}: CollapsibleCardProps) {
  const [open, setOpen] = useState(true)

  return (
    <Card className={cn("px-0", className)}>
      <Collapsible open={open} onOpenChange={setOpen}>
        <div
          className={cn(
            `
              flex items-center justify-between px-3
            `,
            hideTitle && 'justify-end'
          )}
        >
          <h2
            className={cn(
              "text-button-black font-semibold font-poppins text-lg",
              hideTitle && "sr-only"
            )}
          >
            {title}
          </h2>

          {!!actions && <div className="grow">{actions}</div>}

          <CollapsibleTrigger asChild>
            <button
              className={cn(
                "size-7 flex justify-center items-center bg-icon-backfill rounded-full transition-transform hover:cursor-pointer",
                !open && "rotate-180"
              )}
              type="button"
            >
              <Icon name="ChevronUp" className="w-4 h-auto text-icon" />
            </button>
          </CollapsibleTrigger>
        </div>

        <CollapsibleContent className="px-0">{children}</CollapsibleContent>
      </Collapsible>
    </Card>
  )
}
